module.exports = __webpack_public_path__ + "static/media/video-03-tt.d0a0c1bb.webm";